export default __webpack_public_path__ + "static/media/Search_2px.9a74fa70.svg";